import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { server } from "src/constant/axios_config";

// ******* User CRUD *********

export const createUser = createAsyncThunk("create/user", async (userData, { rejectWithValue }) => {
  try {
    const response = await server.post("/users", userData);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

//update userData here
export const UpdateUser = createAsyncThunk("update/user", async ({ id, userData }, { rejectWithValue }) => {
  try {
    const response = await server.patch(`/users/${id}`, userData);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


//update userData here
export const dashboard = createAsyncThunk("dashboard", async (userData, { rejectWithValue }) => {
  try {
    const response = await server.get(`dashboard`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


//update adminDashboard here
export const adminDashboard = createAsyncThunk("admin/dashboard", async (userData, { rejectWithValue }) => {
  try {
    const response = await server.get(`users/admin/dashboard`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


//logout user
export const logoutUser = createAsyncThunk("logout", async (userData, { rejectWithValue }) => {
  try {
    const response = await server.post(`logout?fcm_token=${userData?.fcm_token}`, {});
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

//fetch user data
export const fetchUsers = createAsyncThunk("fetch/user", async (payload, { rejectWithValue }) => {
  try {
    const params = new URLSearchParams({
      ...(payload?.page && { page: payload?.page + 1 }),
      ...(payload?.pageSize && { limit: payload.pageSize }),
      ...(payload?.searchName && { full_name: payload.searchName }),
      sortBy: 'createdAt:desc',
    });
    const response = await server.get(`/users?${params?.toString()}`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

//fetch user by email
export const fetchUserByEmail = createAsyncThunk("fetch/user/email", async (email, { rejectWithValue }) => {
  try {
    const response = await server.get(`user/${email}`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

//Deleate userData here
export const DeleteUser = createAsyncThunk("dDeleteUser/data", async (id, { rejectWithValue }) => {
  try {
    const response = await server.delete(`user/delete/${id}`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

//Read UserData Here
export const ReadUser = createAsyncThunk("ReadUaser/Data", async (userData, { isRejectedWithValue }) => {
  const FetchedDataWithApi = await fetch("http://localhost:4500/v1/user/list")
  try {
    const resultData = await FetchedDataWithApi.json()
    return resultData
  } catch (error) {
    return isRejectedWithValue(error)
  }
})

//fetch user api logs
export const fetchApiLogs = createAsyncThunk("fetch/api/logs", async (payload, { rejectWithValue }) => {
  try {
    const params = new URLSearchParams({
      ...(payload?.page && { page: payload?.page + 1 }),
      ...(payload?.pageSize && { limit: payload.pageSize }),
      ...(payload?.user && { user: payload.user }),
      ...(payload?.startDate && { startDate: payload.startDate }),
      ...(payload?.endDate && { endDate: payload.endDate }),
      sortBy: 'createdAt:desc',
    });
    const response = await server.get(`/api-logs?${params?.toString()}`);
    return response?.data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});


//slices creation for users Data
export const userDetail = createSlice({
  name: "userDetail",
  initialState: {
    users: { limit: 5, results: [], totalPages: 0, totalResults: 0 },
    singleUser: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSingleUser: (state, action) => {
      state.singleUser = action.payload
    },
    resetDeleteSucess: (state) => {
      state.deleteSuccess = false;
    },
    resetRegisterSuccess: (state) => {
      state.registerSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // create user
      .addCase(createUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.success) {
          toast.success('User Created Successfully');
        }
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
      })

      // fetch all user
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.users = {}
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);

        state.loading = false;
        state.users = action.payload || {};
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = false;
      })


      // fetch user by email
      .addCase(fetchUserByEmail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserByEmail.fulfilled, (state, action) => {
        state.loading = false;
        toast.success('User Updated Successfully');
      })
      .addCase(fetchUserByEmail.rejected, (state, action) => {
        state.loading = false;
      })

      // delete user
      .addCase(DeleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteUser.fulfilled, (state, action) => {
        state.loading = false;
        toast.success("User Deleted Successfully")
      })
      .addCase(DeleteUser.rejected, (state, action) => {
        state.loading = false;
      })

      // update user
      .addCase(UpdateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
  },
});

export default userDetail.reducer;
export const userAction = userDetail?.actions;
export const { resetRegisterSuccess, resetDeleteSucess } = userDetail.actions;
